module.exports = __webpack_public_path__ + "img/cinema2.b018b3b5.jpg";